import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './Gift.css';

const Gift = () => {
    const { t } = useTranslation();
    const [copied, setCopied] = useState(false);

    const bankAccount = 'ES67 0182 6855 8302 0173 3521';

    const copyToClipboard = () => {
        navigator.clipboard.writeText(bankAccount.replace(/\s/g, ''));
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    return (
        <section id="gift">
            <h2>{t('gift_title')}</h2>
            <div className="gift-container">
                <div className="gift-icon">🎁</div>
                <p className="gift-message">{t('gift_message')}</p>

                <div className="bank-account-container">
                    <h3>{t('gift_bank_account')}</h3>
                    <div className="bank-account-box">
                        <span className="bank-account-number">{bankAccount}</span>
                        <button
                            className={`copy-button ${copied ? 'copied' : ''}`}
                            onClick={copyToClipboard}
                            aria-label={t('gift_copy')}
                        >
                            {copied ? '✓' : '📋'}
                        </button>
                    </div>
                    {copied && <p className="copy-confirmation">{t('gift_copied')}</p>}
                </div>
            </div>
        </section>
    );
};

export default Gift;
